import styled from "styled-components";

export const EditorContainer = styled.div`
  .ProseMirror {
    .mention {
      background-color: var(--background-primary-canvas);
      border: 1px solid var(--border-primary-subtle);
      border-radius: 4px;
      padding: 2px 4px;
      color: var(--primary);
      font-weight: 500;
    }

    .tool-mention {
      background-color: #E8F5E9;
      border: 1px solid #4CAF50;
      border-radius: 4px;
      padding: 2px 4px;
      color: #2E7D32;
      font-weight: 500;
    }
  }
`;

export const PlusButtonDot = styled.span.withConfig({
  shouldForwardProp: (prop) => prop !== '$flashing',
})<{ $flashing: boolean }>`
  position: absolute;
  top: 2px;
  right: 2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #DC2626;
  border: 1.5px solid #FFFFFF;
  box-sizing: content-box;
  pointer-events: none;
  box-shadow: 0 0 0 0 rgba(220, 38, 38, 0);
  ${props => props.$flashing && `
    animation: plus-button-dot-glow 1s ease-out infinite;
  `}

  @keyframes plus-button-dot-glow {
    0% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.75); }
    70% { box-shadow: 0 0 0 6px rgba(220, 38, 38, 0); }
    100% { box-shadow: 0 0 0 0 rgba(220, 38, 38, 0); }
  }
`;
